import { createQueryKeys } from '@lukemorales/query-key-factory';

import { RequestForQuoteViewFilterMessage } from '../../../../types/RequestForQuoteViewFilterMessage';
import { getRequestForQuote, getRequestForQuotesPage, getRequestsForQuotesCount } from '../clients/gateway.api';

export const requestsForQuotes = createQueryKeys('requestsForQuotes', {
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getRequestForQuote(id),
    }),
    pagination: (params: RequestForQuoteViewFilterMessage) => ({
        queryKey: [{ params }],
        queryFn: () => getRequestForQuotesPage(params),
    }),
    count: (params: RequestForQuoteViewFilterMessage) => ({
        queryKey: [{ params }],
        queryFn: () => getRequestsForQuotesCount(params),
    }),
    totals: (params: RequestForQuoteViewFilterMessage) => ({
        queryKey: [{ params }],
    }),
});
